import { t as e } from "../../i18n.mjs";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { Download01Icon as r, Edit02Icon as i, InfoCircleIcon as a, Trash02Icon as o } from "@systemeio/icons";
//#region src/components/file-action-menu-item/index.tsx
function s({ children: e, icon: r }) {
	return /* @__PURE__ */ n("span", {
		className: "flex min-w-0 items-center gap-2",
		children: [/* @__PURE__ */ t("span", {
			className: "tablet:hidden contents",
			children: r
		}), /* @__PURE__ */ t("span", {
			className: "min-w-0 truncate",
			children: e
		})]
	});
}
function c({ label: n, dataTestAttributes: r, onClick: i, ...o }) {
	return {
		label: n ?? /* @__PURE__ */ t(s, {
			icon: /* @__PURE__ */ t(a, { "aria-hidden": !0 }),
			children: e("file_manager.file_details")
		}),
		...o,
		dataAttributes: r,
		onSelect: i
	};
}
function l({ label: n, dataTestAttributes: r, onClick: i, ...a }) {
	return {
		label: n ?? /* @__PURE__ */ t(s, {
			icon: /* @__PURE__ */ t(o, { "aria-hidden": !0 }),
			children: e("file_manager.delete")
		}),
		state: "destructive",
		...a,
		dataAttributes: r,
		onSelect: i
	};
}
function u({ label: n, dataTestAttributes: r, onClick: a, ...o }) {
	return {
		label: n ?? /* @__PURE__ */ t(s, {
			icon: /* @__PURE__ */ t(i, { "aria-hidden": !0 }),
			children: e("file_manager.rename")
		}),
		...o,
		dataAttributes: r,
		onSelect: a
	};
}
function d({ label: n, dataTestAttributes: i, onClick: a, ...o }) {
	return {
		label: n ?? /* @__PURE__ */ t(s, {
			icon: /* @__PURE__ */ t(r, { "aria-hidden": !0 }),
			children: e("file_manager.download")
		}),
		...o,
		dataAttributes: i,
		onSelect: a
	};
}
//#endregion
export { l as FileActionMenuDeleteItem, c as FileActionMenuDetailsItem, d as FileActionMenuDownloadItem, u as FileActionMenuRenameItem };
